import { render, staticRenderFns } from "./ModalSync.vue?vue&type=template&id=74553209&"
import script from "./ModalSync.vue?vue&type=script&lang=js&"
export * from "./ModalSync.vue?vue&type=script&lang=js&"
import style0 from "./ModalSync.vue?vue&type=style&index=0&id=74553209&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports